var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isKPIthisQuestion && _vm.foundObjectiveValue !== null)?_c('span',{staticClass:"ml-1"},[_vm._v(" Obj : "+_vm._s(_vm.foundObjectiveValue)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }